import Cookies from 'js-cookie'
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const RequireAuth = ({children, roles}) => {
  
    let userRole = Cookies.get('userRole')
    let location = useLocation()
    
    if (!userRole) {
        return <Navigate to="/login" state={{from : location}} replace />
    } else if (roles && roles === userRole){
        return children
    } else {
        return children
    }

}

export default RequireAuth